
import { _BusinessComment } from '@/entities/business';
import { MessageSquareIcon, SquarePenIcon, TimerIcon, Trash2Icon } from 'lucide-react';
import React from 'react';
import CommentDeleteDialog from './CommentDeletDialog';

type ComentarioCardProps = {
    comment: _BusinessComment;
    user: {
      id: number,
      name: string
    };
    onDelete: () => void;
    onReopenModal: () => void;
};

const CardComment: React.FC<ComentarioCardProps> = ({ comment, onDelete, onReopenModal }) => {

  const createAtCalculate = () => {
    const currentDate = new Date();
    const createdAt = new Date(comment.createdAt);

    const diff_in_time = currentDate.getTime() - createdAt.getTime();
    const diff_in_days = Math.round(diff_in_time / (1000 * 3600 * 24));
    
    const months = Math.round(diff_in_days / 30);

    if (months == 0) {
      const suffix = diff_in_days > 1 ? 'dias' : 'dia';
      return `${diff_in_days} ${suffix}`;
    }

    if (months > 0) {
      const suffix = months > 1 ? 'meses' : 'mês';
      return `${months} ${suffix}`;
    }
  };

  return (
    <div className="w-[95%] pb-2 ml-4 relative before:absolute before:ml-8 before:h-full before:w-0.5 before:bg-indigo-100">
      <div className="relative">
        <div className="md:flex items-center mb-1 px-4">
          <div className="flex items-center space-x-4">
            <div className="flex bg-indigo-400 items-center justify-center w-8 h-8 rounded-full md:order-1">
              <MessageSquareIcon size={14} className='text-white bg-indigo-400'/>
            </div>
          </div>
          <div>
            <div className="flex text-slate-500 items-center ml-4 gap-2 pt-2">
              <span className="text-slate-700">Comentário </span> 
              <p className='text-xs'>de { comment.user.name }</p>
            </div>
            <div className="flex items-center ml-4 gap-2 text-slate-400">
              <span className="text-xs">Criado há {createAtCalculate()}</span>
            </div>
          </div>
        </div>
        <div className="flex justify-between bg-white ml-16 mx-4 p-4 rounded-lg border border-slate-100 text-slate-500 text-sm shadow-xs break-words">
          <div>
            { comment.comment }
          </div>
          
          <div>
            <div className='flex items-center gap-2 px-2'>
              <div className='flex items-center h-10'>
                <CommentDeleteDialog handleDelete={onDelete} />
              </div>
              <button title='Mostrar detalhes' onClick={onReopenModal} className='flex items-center justify-center h-10 -mt-1'>
                <SquarePenIcon size={26} className='bg-indigo-50 hover:bg-indigo-200 rounded-md p-1'  />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardComment;
